import { apiClient, type PageData } from './client'
import type { EmployeeOrder, EmployeeOrderDetailResponse, EmployeeOrderListParams } from '@/types/employee'

export const employeeOrderApi = {
  /** 获取员工订单列表 */
  list: async (params: EmployeeOrderListParams): Promise<PageData<EmployeeOrder>> => {
    const searchParams = new URLSearchParams()
    searchParams.set('page', String(params.page || 1))
    searchParams.set('page_size', String(params.page_size || 30))
    if (params.order_no) searchParams.set('order_no', params.order_no)
    if (params.phone) searchParams.set('phone', params.phone)
    if (params.user_id) searchParams.set('user_id', String(params.user_id))
    if (params.date) searchParams.set('date', params.date)
    const response = await apiClient.get<PageData<EmployeeOrder>>(
      `/employee/orders?${searchParams.toString()}`
    )
    return response.data
  },

  /** 获取员工订单详情 */
  detail: async (id: number): Promise<EmployeeOrderDetailResponse> => {
    const response = await apiClient.get<EmployeeOrderDetailResponse>(
      `/employee/orders/${id}`
    )
    return response.data
  },
}
